"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNameSpacesByConnectResponse = buildNameSpacesByConnectResponse;
exports.buildRequestAccountNameSpacesByConnectResponse = buildRequestAccountNameSpacesByConnectResponse;
exports.buildAccountNameSpaces = buildAccountNameSpaces;
const log_1 = require("../utils/log");
function buildNameSpacesByConnectResponse(connectResponse) {
    let requestAccountNameSpaces = buildRequestAccountNameSpacesByConnectResponse(connectResponse);
    return requestAccountNameSpaces;
}
function buildRequestAccountNameSpacesByConnectResponse(connectResponse) {
    let result = {};
    (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse start connectResponse111>>', JSON.stringify(connectResponse));
    let universalResponse = connectResponse.payload.responses.find(item => item.name === 'requestAccounts');
    if (universalResponse && universalResponse.accounts) {
        let filterAccount = [];
        for (const item of universalResponse.accounts) {
            if (item.namespace === "ton") {
                if (item.data && item.data.ton_addr) {
                    if (item.data.ton_addr.address && item.data.ton_addr.address.length > 0) {
                        (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse start TON>>', JSON.stringify(item));
                        filterAccount.push(item);
                    }
                }
            }
            else {
                (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse start other>>', JSON.stringify(item));
                filterAccount.push(item);
            }
        }
        universalResponse.accounts = filterAccount;
    }
    const tonAddress = connectResponse.payload.responses.find(item => item.name === 'ton_addr');
    const tonProof = connectResponse.payload.responses.find(item => item.name === 'ton_proof');
    if (tonAddress && !universalResponse) { //adapt tonsdk
        (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse adapt ton data >>');
        let address = tonAddress.address;
        address = 'ton:' + tonAddress.network + ":" + address;
        let data = {
            ton_addr: tonAddress
        };
        if (tonProof) {
            data.ton_proof = tonProof;
        }
        universalResponse = {
            name: "requestAccounts",
            accounts: [{
                    namespace: 'ton',
                    addresses: [address],
                    methods: ['ton_sendTransaction'],
                    extra: {},
                    data: data,
                }]
        };
    }
    (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse end universalResponse>>>', JSON.stringify(universalResponse));
    buildAccountNameSpaces(universalResponse.accounts, result);
    return result;
}
function buildAccountNameSpaces(accounts, result) {
    accounts.forEach(item => {
        var chains = [];
        var accounts = [];
        item.addresses.forEach(addressItem => {
            var addressArr = addressItem.split(":");
            (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse addressArr>>', addressArr.length);
            if (addressArr.length >= 3) {
                let chain = addressArr.slice(0, 2).join(":");
                chains.push(chain);
                accounts.push(addressItem);
                (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse chain:>>', chain, "addressItem:", addressItem);
            }
        });
        if (item.data && item.data.ton_addr) {
            item.data.ton_addr.name = 'ton_addr';
        }
        if (item.data && item.data.ton_proof) {
            item.data.ton_proof.name = 'ton_proof';
        }
        result[item.namespace] = {
            chains: chains,
            accounts: accounts,
            methods: item.methods,
            extra: item.extra,
            payload: item.data
        };
        (0, log_1.logDebug)('buildRequestAccountNameSpacesByConnectResponse result>>', JSON.stringify(result));
    });
}
/*export function buildTonNameSpaceByConnectResponse(connectResponse: ConnectResponseSuccess): Namespaces | undefined {
    const tonAddrItem: TonAddressItemReply = connectResponse.payload.responses.find(
        item => item.name === 'ton_addr'
    ) as TonAddressItemReply;

    const tonProfItem: TonProofItemReply = connectResponse.payload.responses.find(
        item => item.name === 'ton_proof'
    ) as TonProofItemReply;

    if (!tonAddrItem) {
        return undefined
    }

    return {
        NameSpaceKeyTON: {
            chains: [tonAddrItem.network],
            accounts: [],
            methods: connectResponse.payload.wallet.features?.ton,
            payload: {
                tonAccount: {
                    address: tonAddrItem.address,
                    chain: tonAddrItem.network,
                    walletStateInit: tonAddrItem.walletStateInit,
                    publicKey: tonAddrItem.publicKey
                },
                tonProof: tonProfItem
            }
        }
    }
}*/
